import { Component, OnInit, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { PersonneState, PopupModel, HidePopup } from '../../../personne.state';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-popup-container',
  templateUrl: './popup-container.component.html',
  styleUrls: ['./popup-container.component.scss'],
  standalone: false
})
export class PopupContainerComponent implements OnInit, OnDestroy {
  @Select(PersonneState.popup)
  popup$: Observable<PopupModel>;
  popupSubscription: Subscription;
  name: string;
  params: any;

  estAffiche = false;

  constructor(private readonly _store: Store) {}

  ngOnInit() {
    this.popupSubscription = this.popup$.subscribe(data => {
      this.name = data.displayedName;
      this.params = data.params;
      this.estAffiche = this.name !== null;
    });
  }

  ngOnDestroy(): void {
    if (this.popupSubscription) {
      this.popupSubscription.unsubscribe();
    }
  }

  close() {
    this._store.dispatch(new HidePopup());
  }
}
